import React from 'react';

import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';

function PageLoading() {
  return (
    <Grid container>
      <Grid sx={{ mt: 10, alignSelf: 'center' }} size={12}>
        <CircularProgress size={150} data-cy="loading" />
      </Grid>
    </Grid>
  );
}

export default PageLoading;
